import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="container py-5">
      <h1 className="h3">Page not found</h1>
      <Link to="/">Go home</Link>
    </div>
  )
}
